import type { FaireProductEntity } from "../../entity_types/product";

export const p_e69ewgrnz7: FaireProductEntity = {
  token: "p_e69ewgrnz7",
  type: "product",
  name: "925 Talia ring",
  brandToken: "b_pnfabwsu5v",
  brandName: "Glam Bar Bazaar",
  imageUrl:
    "https://cdn.faire.com/fastly/43ec46f753dc88c6d46c834ede595e410d94bd855c331a428c46855c82b0f604.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af17c9a497f9343119576324b4fb668faff3b3d71d0fff07aada49a00d76ead5.jpeg",
    "https://cdn.faire.com/fastly/8c396c198dad8cddf6db88e1b8b04bf107a558ec8d59dff77793851515259ce9.jpeg",
  ],
  priceDollars: 37.2,
  description:
    "Materials:\n\n925 Sterling Silver plated 18k gold\n\nAAAAA Cubic zirconia \n",
  tags: [],
  msrpDollars: 62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:54.096Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
